module.exports = __webpack_public_path__ + "static/media/arrow-square-up.1fc5ac06.svg";